import { FreightForwarderBidDto } from './api/freight-forwarder-bid';

/**
 * Выгода от конкурса: насколько выбранная ставка дешевле средней по остальным ставкам запроса.
 * Считаем только там, где было хотя бы две ставки; если выбрана ставка дороже средней — выгоды нет (не минус).
 * Ставки в разных валютах сравниваются: для компании в ₸ — по priceKzt с сервера, для остальных — только ставки
 * в валюте компании (курса на дату ставки пока нет).
 */
export function bidValue(b: FreightForwarderBidDto, currency: string): number | null {
  if (currency === 'KZT') return b.priceKzt ?? (b.currencyCode === 'KZT' ? b.price : null);
  return b.currencyCode === currency ? b.price : null;
}

export interface CompetitionGain {
  /** На сколько выбранная дешевле средней по остальным; 0 — если не дешевле. */
  gain: number;
  /** Сколько других ставок участвовало в сравнении. */
  others: number;
}

export function competitionGain(bids: FreightForwarderBidDto[], chosenId: number | null | undefined, currency: string): CompetitionGain | null {
  const chosen = bids.find(b => b.id === chosenId);
  const value = chosen ? bidValue(chosen, currency) : null;
  if (value == null) return null;
  const others = bids.filter(b => b.id !== chosenId).map(b => bidValue(b, currency)).filter((v): v is number => v != null);
  if (!others.length) return null;
  const avg = others.reduce((s, v) => s + v, 0) / others.length;
  return { gain: Math.max(0, Math.round(avg - value)), others: others.length };
}
